import React from 'react';
import { Route } from 'react-router';
import PortalRemovalNotice from './components/PortalRemovalNotice';

const routes = <Route path="/" component={PortalRemovalNotice} />;

export default routes;
